<template>
  <div v-if="$store.state.app.appNavBar && $store.state.app.allSites.length>0">
    <b-form-select
      v-model="selected"
      :options="$store.state.app.allSites"
      value-field="idsite"
      text-field="label"
      clearable
    />
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'
import emitter from '@core/utils/emitter'
import store from '@/store'
import hmStorage from '@core/utils/hm_storage'

export default {
  components: {
    BFormSelect
  },
  computed: {
    selected: {
      get() {
        return store.state.app.idsite
      },
      set(idsite) {
        store.commit('app/SET_APP_STATE', { idsite })
        hmStorage.setLocalItem('idsite', idsite)
        emitter.emit('change_site', { selected: this.selected })
      }
    }
  }
}
</script>
